import { render, staticRenderFns } from "./MultiValueReferencesInput.vue?vue&type=template&id=8ad848ac&"
import script from "./MultiValueReferencesInput.vue?vue&type=script&lang=ts&"
export * from "./MultiValueReferencesInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports